import React from 'react';
import { action, observable } from "mobx";

export default class CheckBoxTransformer {
    transform(value='', onChangeHandle) {
            
        //console.log(ev)
        return (
            <div style={{color: 'red', justifyContent:'center'}}>
                <input 
                    type="checkbox" 
                    onChange={ (ev)=>{
                        console.log('inner shit', onChangeHandle, ev);
                        onChangeHandle(ev.target)
                    }  } 
                    value={value}
                    defaultChecked="false"
                /> 
                n
            </div>
        );
    }
}